import React, { useState } from "react";
import { ShieldCheckIcon, BadgeCheckIcon } from "lucide-react";
import { Button } from "@component/button";

interface PreviewEmailOTPVerifyProps {
    onNextStep: () => void;
}

export default function PreviewEmailOTPVerify({ onNextStep }: PreviewEmailOTPVerifyProps) {
    const [isVerified, setIsVerified] = useState(false);
    const otpValues = ["", "", "", "", "", ""];

    return (
        <div className="flex flex-col items-center justify-center min-h-[350px]">
            <div className="flex flex-col items-center justify-center text-center w-full max-w-md mx-auto">
                <div className="mb-2 md:mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-full">
                    <ShieldCheckIcon className="h-8 md:h-12 w-8 md:w-12 text-blue-500" />
                </div>
                <h2 className="text-lg md:text-3xl font-bold mb-2">
                    Verify your email
                </h2>
                <p className="mb-6">
                    We've sent a verification code to{" "}
                    <span className="font-medium text-blue-600">candidate@email.com</span>.
                </p>

                {!isVerified ? (
                    <>
                        <div className="flex justify-center gap-2 mb-6">
                            {otpValues.map((_, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength={1}
                                    value=""
                                    disabled
                                    className="w-12 h-12 text-center text-xl font-bold border border-gray-300 dark:border-gray-700 rounded-md bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none cursor-not-allowed"
                                />
                            ))}
                        </div>

                        <Button
                            variant="default"
                            className="w-full mb-4"
                            onClick={() => setIsVerified(true)}
                        >
                            Verify Email
                        </Button>

                        <div className="text-sm text-gray-500 dark:text-gray-400">
                            <p>Resend code in 60 seconds.</p>
                        </div>
                    </>
                ) : (
                    <div className="flex flex-col items-center">
                        <p className="text-black mb-6 flex items-center gap-2">
                            <BadgeCheckIcon className="h-5 w-5 text-green-600 dark:text-green-500" />
                            Email verified successfully!
                        </p>
                        <Button variant="default" onClick={onNextStep} className="w-full rounded-full">
                            Continue
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
